import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import '../Customize_Css/ViewStocks.css';
import { Modal, Button, Table, Card, Dropdown, Form } from 'react-bootstrap';
import { FaPlus, FaTrashAlt, FaEdit, FaSearch, FaWarehouse, FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';

const ViewStocks = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const AuthorizationToken = localStorage.getItem('token');
    const epicxTenantId = localStorage.getItem('epicxTenantId');
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [message, setMessage] = useState("");
    const [isCalendarised, setIsCalendarised] = useState(false);
    const [isIndianCalendar, setIsIndianCalendar] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [indianCalendarDate, setIndianCalendarDate] = useState('');
    const [errors, setErrors] = useState({});
    const [validFields, setValidFields] = useState({});
    const [editData, setEditData] = useState({
        productName: '',
        availabilityStatus: '',
        stock: '',
        buyingPrice: '',
        sellingPrice: '',
        price: '',
        offerType: '',
        offerPrice: '',
        productWeightOption1: { weight: '', stock: '', price: '', offerPrice: '' },
        productWeightOption2: { weight: '', stock: '', price: '', offerPrice: '' },
        productWeightOption3: { weight: '', stock: '', price: '', offerPrice: '' },
        productWeightOption4: { weight: '', stock: '', price: '', offerPrice: '' },
    });

    useEffect(() => {
        fetchAllStocks();
        fetchVendors();
    }, [epicxTenantId]);

    const fetchAllStocks = async () => {
        try {
            const allProductsUrl = `${BASE_URL}/products/api/productDetails/${epicxTenantId}/stocks`;
            const allProductsResponse = await axios.get(allProductsUrl, {
                headers: {
                    Authorization: `Bearer ${AuthorizationToken}`,
                },
            });
            setData(allProductsResponse.data);
        } catch (error) {
            console.error('Error fetching all products:', error);
            toast.error(`Error fetching all products: ${error.message}`);
        }
    };

    const fetchProducts = async (vendorName) => {
        if (!vendorName) {
            setData([]);
            setMessage("No products available for this stock segment.");
            return;
        }
        try {
            const url = `${BASE_URL}/products/api/productDetails/${epicxTenantId}/stocks/productVendor?productVendorName=${encodeURIComponent(vendorName)}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${AuthorizationToken}`,
                },
            });
            if (response.data.length === 0) {
                setData([]);
                setMessage("No products available for this stock segment.");
            } else {
                setData(response.data);
                setMessage("");
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            setMessage("No products available for this segment");
        }
    };

    const fetchVendors = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}`, {
                headers: {
                    Authorization: `Bearer ${AuthorizationToken}`,
                },
            });
            setVendors(response.data.vendors);
        } catch (error) {
            console.error("Error fetching vendors:", error);
        }
    };

    const handleVendorChange = (event) => {
        const vendorName = event.target.value;
        setSelectedVendor(vendorName);
        setSelectedItems([]);
        setCurrentPage(1);
        fetchProducts(vendorName);
    };

    const handleSearch = (value) => {
        setSearchTerm(value.toLowerCase());
        setCurrentPage(1);
    };

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredData = data.filter((item) =>
        Object.keys(item).some((key) => {
            const value = item[key];
            return value !== null && value !== undefined && value.toString().toLowerCase().includes(searchTerm);
        })
    );

    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const handleViewMore = (product) => {
        setSelectedProduct(product);
        setShowModal(true);
        setEditMode(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setShowEditModal(false);
        setSelectedProduct(null);
        setErrors({});
        setValidFields({});
        setEditData({
            productName: '',
            availabilityStatus: '',
            stock: '',
            buyingPrice: '',
            sellingPrice: '',
            price: '',
            offerType: '',
            offerPrice: '',
            productWeightOption1: { weight: '', stock: '', price: '', offerPrice: '' },
            productWeightOption2: { weight: '', stock: '', price: '', offerPrice: '' },
            productWeightOption3: { weight: '', stock: '', price: '', offerPrice: '' },
            productWeightOption4: { weight: '', stock: '', price: '', offerPrice: '' },
        });
        setIsCalendarised(false);
        setIsIndianCalendar(false);
        setStartDate('');
        setEndDate('');
        setIndianCalendarDate('');
    };

    const handleSelectItem = (id) => {
        setSelectedItems((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((itemId) => itemId !== id)
                : [...prevSelected, id]
        );
    };

    // Offer price for a weight option, using the offer settings passed in
    // so a change to percentage or offer value updates the rows below immediately.
    const calculateOfferPrice = (optionPrice, offerType = editData.offerType, offerValue = editData.offerPrice) => {
        if (optionPrice === '' || optionPrice === null || optionPrice === undefined) return '';
        if (!offerType || offerValue === '' || offerValue === null || offerValue === undefined) return '';
        const priceNum = Number(optionPrice);
        const offerPriceNum = Number(offerValue);
        if (!Number.isFinite(priceNum) || !Number.isFinite(offerPriceNum)) return '';
        let result = null;
        if (offerType === 'fixed') {
            result = priceNum - offerPriceNum;
        } else if (offerType === 'percentage') {
            result = priceNum - (priceNum * offerPriceNum) / 100;
        }
        if (result === null) return '';
        return result >= 0 ? result.toFixed(2) : 'Invalid';
    };

    const applyOfferToWeightOptions = (data, offerType, offerValue) => {
        const next = { ...data, offerType, offerPrice: offerValue };
        [1, 2, 3, 4].forEach((index) => {
            const key = `productWeightOption${index}`;
            const option = { ...(data[key] || { weight: '', stock: '', price: '', offerPrice: '' }) };
            const calculated = calculateOfferPrice(option.price, offerType, offerValue);
            option.offerPrice = calculated && calculated !== 'Invalid' ? calculated : '';
            next[key] = option;
        });
        return next;
    };

    const validateField = (id, value, productName = null, offerContext = null) => {
        const activeOfferType = offerContext?.offerType ?? editData.offerType;
        const activeOfferValue = offerContext?.offerValue ?? editData.offerPrice;
        const isEmpty = (val) => !val || val.toString().trim() === '';
        const isValidPositiveNumber = (val) => !isNaN(val) && Number(val) > 0;

        const key = productName ? `${productName}-${id}` : id;

        const validationRules = {
            buyingPrice: {
                message: 'Buying Price must be a positive number',
                validator: isValidPositiveNumber,
            },
            sellingPrice: {
                message: 'Selling Price must be a positive number',
                validator: isValidPositiveNumber,
            },
            price: {
                message: 'Base Price is required and must be a positive number',
                validator: isValidPositiveNumber,
            },
            offerType: {
                message: 'Offer Type is required',
                validator: (val) => ['fixed', 'percentage'].includes(val),
            },
            offerPrice: {
                message: 'Offer Price is required and must be a positive number',
                validator: (val) => isValidPositiveNumber(val) && (activeOfferType !== 'percentage' || Number(val) <= 100),
            },
            availabilityStatus: {
                message: 'Availability Status is required',
                validator: (val) => !isEmpty(val),
            },
            weightOption1: {
                message: 'Weight Option 1 is required with valid weight, stock, price, and calculated offer price',
                validator: (val) => {
                    const calculatedOfferPrice = calculateOfferPrice(val.price, activeOfferType, activeOfferValue);
                    return (
                        (val.weight || '').toString().trim() &&
                        isValidPositiveNumber(val.stock) &&
                        isValidPositiveNumber(val.price) &&
                        calculatedOfferPrice !== 'Invalid' &&
                        isValidPositiveNumber(calculatedOfferPrice)
                    );
                },
            },
            weightOption2: {
                message: 'Stock and calculated offer price are required for Weight Option 2 if weight is provided',
                validator: (val) => {
                    if (!(val.weight || '').toString().trim()) return true;
                    const calculatedOfferPrice = calculateOfferPrice(val.price, activeOfferType, activeOfferValue);
                    return (
                        isValidPositiveNumber(val.stock) &&
                        isValidPositiveNumber(val.price) &&
                        calculatedOfferPrice !== 'Invalid' &&
                        isValidPositiveNumber(calculatedOfferPrice)
                    );
                },
            },
            weightOption3: {
                message: 'Stock and calculated offer price are required for Weight Option 3 if weight is provided',
                validator: (val) => {
                    if (!(val.weight || '').toString().trim()) return true;
                    const calculatedOfferPrice = calculateOfferPrice(val.price, activeOfferType, activeOfferValue);
                    return (
                        isValidPositiveNumber(val.stock) &&
                        isValidPositiveNumber(val.price) &&
                        calculatedOfferPrice !== 'Invalid' &&
                        isValidPositiveNumber(calculatedOfferPrice)
                    );
                },
            },
            weightOption4: {
                message: 'Stock and calculated offer price are required for Weight Option 4 if weight is provided',
                validator: (val) => {
                    if (!(val.weight || '').toString().trim()) return true;
                    const calculatedOfferPrice = calculateOfferPrice(val.price, activeOfferType, activeOfferValue);
                    return (
                        isValidPositiveNumber(val.stock) &&
                        isValidPositiveNumber(val.price) &&
                        calculatedOfferPrice !== 'Invalid' &&
                        isValidPositiveNumber(calculatedOfferPrice)
                    );
                },
            },
            startDate: {
                message: 'Start Date is required',
                validator: (val) => !isEmpty(val),
            },
            endDate: {
                message: 'End Date is required',
                validator: (val) => !isEmpty(val),
            },
            indianCalendarDate: {
                message: 'Indian Calendar Date is required',
                validator: (val) => !isEmpty(val),
            },
        };

        const rule = validationRules[id];
        if (!rule) return true;

        const isValid = rule.validator(value);
        setErrors((prev) => ({
            ...prev,
            [key]: isValid ? '' : rule.message,
        }));
        setValidFields((prev) => ({
            ...prev,
            [key]: isValid,
        }));
        return isValid;
    };

    const validateProductDetailsStockForm = () => {
        let isValid = true;
        const fieldsToValidate = [
            { id: 'availabilityStatus', value: editData.availabilityStatus },
            { id: 'buyingPrice', value: editData.buyingPrice },
            { id: 'sellingPrice', value: editData.sellingPrice },
            { id: 'price', value: editData.price },
            { id: 'offerType', value: editData.offerType },
            { id: 'offerPrice', value: editData.offerPrice },
            { id: 'weightOption1', value: editData.productWeightOption1 },
        ];

        if ((editData.productWeightOption2.weight || '').toString().trim()) {
            fieldsToValidate.push({ id: 'weightOption2', value: editData.productWeightOption2 });
        }
        if ((editData.productWeightOption3.weight || '').toString().trim()) {
            fieldsToValidate.push({ id: 'weightOption3', value: editData.productWeightOption3 });
        }
        if ((editData.productWeightOption4.weight || '').toString().trim()) {
            fieldsToValidate.push({ id: 'weightOption4', value: editData.productWeightOption4 });
        }
        if (isCalendarised) {
            fieldsToValidate.push(
                { id: 'startDate', value: startDate },
                { id: 'endDate', value: endDate }
            );
        }
        if (isIndianCalendar) {
            fieldsToValidate.push({ id: 'indianCalendarDate', value: indianCalendarDate });
        }

        fieldsToValidate.forEach(({ id, value }) => {
            if (!validateField(id, value)) {
                isValid = false;
            }
        });

        return isValid;
    };

    const totalQuantityFromOptions = (data) => {
        return [1, 2, 3, 4].reduce((total, index) => {
            const qty = data[`productWeightOption${index}`]?.stock;
            if (qty === '' || qty === null || qty === undefined) return total;
            const amount = Number(qty);
            return Number.isNaN(amount) ? total : total + amount;
        }, 0);
    };

    // Edit
    const openEditForProduct = (product) => {
        const nextEditData = {
            productName: product.productName || '',
            availabilityStatus: product.availabilityStatus || 'available',
            stock: '',
            buyingPrice: product.buyingPrice || '',
            sellingPrice: product.sellingPrice || '',
            price: product.sellingPrice || '',
            offerType: product.offerType || '',
            offerPrice: product.offerPrice || '',
            productWeightOption1: product.productWeightOption1 || { weight: '', stock: '', price: '', offerPrice: '' },
            productWeightOption2: product.productWeightOption2 || { weight: '', stock: '', price: '', offerPrice: '' },
            productWeightOption3: product.productWeightOption3 || { weight: '', stock: '', price: '', offerPrice: '' },
            productWeightOption4: product.productWeightOption4 || { weight: '', stock: '', price: '', offerPrice: '' },
        };
        nextEditData.stock = totalQuantityFromOptions(nextEditData);
        setSelectedProduct(product);
        setEditData(nextEditData);
        const savedStartDate = product.calendarised ? toDateInputValue(product.startDate) : '';
        const savedEndDate = product.calendarised ? toDateInputValue(product.endDate) : '';
        const savedIndianCalendarDate = product.indianCalendar ? toDateInputValue(product.indianCalendarDate) : '';
        setIsCalendarised(product.calendarised || false);
        setIsIndianCalendar(product.indianCalendar || false);
        setStartDate(savedStartDate);
        setEndDate(savedEndDate);
        setIndianCalendarDate(savedIndianCalendarDate);
        if (product.calendarised) {
            validateField('startDate', savedStartDate);
            validateField('endDate', savedEndDate);
        }
        if (product.indianCalendar) {
            validateField('indianCalendarDate', savedIndianCalendarDate);
        }
        setShowEditModal(true);
        setEditMode(true);
    };

    const handleEditAction = () => {
        if (!selectedVendor) {
            toast.warn('Please select a vendor.');
            return;
        }
        if (selectedItems.length > 0) {
            const product = currentData.find((item) => item._id === selectedItems[0]);
            if (!product) {
                toast.warn('Please select a product to edit.');
                return;
            }
            openEditForProduct(product);
        } else {
            toast.warn('Please select at least one product to edit.');
        }
    };

    // Format date for display text
    const formatDate = (date) => {
        if (!date) return 'N/A';
        const parsed = new Date(date);
        if (Number.isNaN(parsed.getTime())) return 'N/A';
        return parsed.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    // Date inputs only accept yyyy-mm-dd. Saved values may arrive as ISO strings.
    const toDateInputValue = (date) => {
        if (!date || date === 'N/A') return '';
        if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
            return date.slice(0, 10);
        }
        const parsed = new Date(date);
        if (Number.isNaN(parsed.getTime())) return '';
        const year = parsed.getFullYear();
        const month = String(parsed.getMonth() + 1).padStart(2, '0');
        const day = String(parsed.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleUpdateProductStock = async () => {
        if (!validateProductDetailsStockForm()) {
            toast.error('Please fix the validation errors before submitting.');
            return;
        }

        try {
            const url = `${BASE_URL}/products/api/productDetails/${epicxTenantId}/${selectedVendor}/${selectedProduct._id}/update`;
            const updatedData = {
                productName: editData.productName,
                availabilityStatus: editData.availabilityStatus,
                stock: Number(editData.stock) || 0,
                buyingPrice: Number(editData.buyingPrice),
                sellingPrice: Number(editData.sellingPrice),
                offerType: editData.offerType,
                offerPrice: Number(editData.offerPrice),
                calendarised: isCalendarised,
                indianCalendar: isIndianCalendar,
                startDate: isCalendarised ? toDateInputValue(startDate) : null,
                endDate: isCalendarised ? toDateInputValue(endDate) : null,
                indianCalendarDate: isIndianCalendar ? toDateInputValue(indianCalendarDate) : null,
                productWeightOption1: {
                    weight: Number(editData.productWeightOption1.weight) || undefined,
                    stock: Number(editData.productWeightOption1.stock) || 0,
                    price: Number(editData.productWeightOption1.price),
                    offerPrice: Number(calculateOfferPrice(editData.productWeightOption1.price)),
                },
                productWeightOption2: (editData.productWeightOption2.weight || '').toString().trim()
                    ? {
                          weight: Number(editData.productWeightOption2.weight) || undefined,
                          stock: Number(editData.productWeightOption2.stock) || 0,
                          price: Number(editData.productWeightOption2.price),
                          offerPrice: Number(calculateOfferPrice(editData.productWeightOption2.price)),
                      }
                    : undefined,
                productWeightOption3: (editData.productWeightOption3.weight || '').toString().trim()
                    ? {
                          weight: Number(editData.productWeightOption3.weight) || undefined,
                          stock: Number(editData.productWeightOption3.stock) || 0,
                          price: Number(editData.productWeightOption3.price),
                          offerPrice: Number(calculateOfferPrice(editData.productWeightOption3.price)),
                      }
                    : undefined,
                productWeightOption4: (editData.productWeightOption4.weight || '').toString().trim()
                    ? {
                          weight: Number(editData.productWeightOption4.weight) || undefined,
                          stock: Number(editData.productWeightOption4.stock) || 0,
                          price: Number(editData.productWeightOption4.price),
                          offerPrice: Number(calculateOfferPrice(editData.productWeightOption4.price)),
                      }
                    : undefined,
                aboutTheProduct: selectedProduct?.aboutTheProduct || '',
                benefits: selectedProduct?.benefits || '',
                storageAndUse: selectedProduct?.storageAndUse || '',
                categoryName: selectedProduct?.categoryName || '',
                measurement: selectedProduct?.measurement || '',
                productVendorName: selectedVendor,
            };
            await axios.put(url, updatedData, {
                headers: {
                    Authorization: `Bearer ${AuthorizationToken}`,
                },
            });
            toast.success("Product Stocks Updated successfully!");
            handleCloseModal();
            fetchProducts(selectedVendor);
        } catch (error) {
            console.error('Error updating product:', error);
            toast.error(`Error updating product: ${error.response?.data?.message || error.message}`);
        }
    };

    // Move stock back to the products list (statusCode 2). Does not soft-delete the product.
    const handleDeleteActionStock = () => {
        if (!selectedVendor) {
            toast.warn('Please select a vendor.');
            return;
        }
        if (selectedItems.length === 0) {
            toast.warn('Please select a product to delete.');
            return;
        }
        const product = data.find((item) => item._id === selectedItems[0]);
        setDeleteTarget(product || { _id: selectedItems[0], productName: 'this stock', productVendorName: selectedVendor });
    };

    const confirmDeleteStock = async () => {
        const selectedProductId = deleteTarget?._id;
        const vendorName = deleteTarget?.productVendorName || selectedVendor;
        const apiUrl = `${BASE_URL}/products/api/productDetails/${epicxTenantId}/${encodeURIComponent(vendorName)}/${selectedProductId}/delete`;
        try {
            const response = await fetch(apiUrl, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${AuthorizationToken}`,
                },
            });
            if (response.ok) {
                toast.success('Stock removed. Product moved to the products list.', {
                    className: 'custom-success-toast',
                });
                setSelectedItems([]);
                setDeleteTarget(null);
                if (selectedVendor) {
                    fetchProducts(selectedVendor);
                } else {
                    fetchAllStocks();
                }
            } else {
                const result = await response.json();
                toast.error(`Error: ${result.message || 'An error occurred'}`);
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            toast.error(`Error: ${error.message}`);
        }
    };

    return (
        <>
            <Sidebar />
            <div className="stocks-page" style={{ paddingBottom: !showModal && !showEditModal ? '48px' : 0 }}>
                <header className="stocks-hero">
                    <div>
                        <p className="stocks-kicker">Inventory</p>
                        <h1>Stocks List</h1>
                        <p>Monitor quantities, pricing, and product stock across your vendors.</p>
                    </div>
                    <button
                        className="stocks-primary-btn"
                        onClick={() => navigate(`/Add-Stock`)}
                    >
                        <FaPlus /> Add Stock
                    </button>
                </header>

                <section className="stocks-toolbar" aria-label="Stock filters">
                    <div className="stocks-filter">
                        <label htmlFor="vendorDropdown">Vendor</label>
                        <select
                            className="form-select"
                            id="vendorDropdown"
                            value={selectedVendor}
                            onChange={handleVendorChange}
                        >
                            <option value="">Select Vendor</option>
                            {vendors.map((vendor) => (
                                <option key={vendor.id} value={vendor.vendorName}>
                                    {vendor.vendorName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="stocks-toolbar-actions">
                        <div className="stocks-search">
                            <FaSearch aria-hidden="true" />
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search stocks..."
                                    aria-label="Search stocks"
                                    value={searchTerm}
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                        </div>
                        <Dropdown>
                            <Dropdown.Toggle className="stocks-action-btn">
                                Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={handleDeleteActionStock}>
                                    <FaTrashAlt className="me-2" /> Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </section>

                <div>
                    <Card className="stocks-card">
                        <div className="stocks-card-head">
                            <div>
                                <h2>Stock Products</h2>
                                <p>{selectedVendor ? `Showing stock from ${selectedVendor}` : 'Select a vendor to view stock'}</p>
                            </div>
                            <span className="stocks-count">
                                <FaWarehouse aria-hidden="true" />
                                {filteredData.length} {filteredData.length === 1 ? 'product' : 'products'}
                            </span>
                        </div>
                        <Card.Body className="stocks-card-body">
                            <Table responsive className="stocks-table">
                                <colgroup>
                                    <col className="col-check" />
                                    <col className="col-name" />
                                    <col className="col-vendor" />
                                    <col className="col-type" />
                                    <col className="col-cat" />
                                    <col className="col-measure" />
                                    <col className="col-opt1" />
                                    <col className="col-opt2" />
                                    <col className="col-opt3" />
                                    <col className="col-opt3" />
                                    <col className="col-buy" />
                                    <col className="col-sell" />
                                    <col className="col-total" />
                                    <col className="col-action" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th className="stocks-check-cell">
                                            <input
                                                className="stocks-checkbox"
                                                type="checkbox"
                                                aria-label="Select all stock products on this page"
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedItems(currentData.map((item) => item._id));
                                                    } else {
                                                        setSelectedItems([]);
                                                    }
                                                }}
                                                checked={selectedItems.length === currentData.length && currentData.length > 0}
                                            />
                                        </th>
                                        <th>Product Name</th>
                                        <th className="stocks-vendor-cell">Vendor</th>
                                        <th>Product Type</th>
                                        <th>Category</th>
                                        <th>Measurement</th>
                                        <th>Option 1 Stock</th>
                                        <th>Option 2 Stock</th>
                                        <th>Option 3 Stock</th>
                                        <th>Option 4 Stock</th>
                                        <th className="stocks-price-cell">Buying Price</th>
                                        <th className="stocks-price-cell">Selling Price</th>
                                        <th className="stocks-total-cell">Total Stock</th>
                                        <th className="stocks-action-cell">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {message || currentData.length === 0 ? (
                                        <tr>
                                            <td colSpan="14">
                                                <div className="stocks-empty">
                                                    <span><FaWarehouse aria-hidden="true" /></span>
                                                    <h3>No stock products found</h3>
                                                    <p>{message || 'Select a vendor or adjust your search.'}</p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        currentData.map((item) => {
                                            // Calculate total stock from all weight options
                                            const totalStock =
                                                (item.productWeightOption1?.stock || 0) +
                                                (item.productWeightOption2?.stock || 0) +
                                                (item.productWeightOption3?.stock || 0) +
                                                (item.productWeightOption4?.stock || 0);

                                            return (
                                                <tr key={item._id} className={selectedItems.includes(item._id) ? 'is-selected' : ''}>
                                                    <td className="stocks-check-cell">
                                                        <input
                                                            className="stocks-checkbox"
                                                            type="checkbox"
                                                            aria-label={`Select ${item.productName}`}
                                                            checked={selectedItems.includes(item._id)}
                                                            onChange={() => handleSelectItem(item._id)}
                                                        />
                                                    </td>
                                                    <td><span className="stocks-product-name">{item.productName}</span></td>
                                                    <td className="stocks-vendor-cell">{item.productVendorName}</td>
                                                    <td><span className="stocks-type-badge">{item.productType}</span></td>
                                                    <td><span className="stocks-category-badge">{item.categoryName}</span></td>
                                                    <td><span className="stocks-measurement">{item.measurement}</span></td>
                                                    <td>{item.productWeightOption1?.stock || '-'}</td>
                                                    <td>{item.productWeightOption2?.stock || '-'}</td>
                                                    <td>{item.productWeightOption3?.stock || '-'}</td>
                                                    <td>{item.productWeightOption4?.stock || '-'}</td>
                                                    <td className="stocks-price-cell">{item.buyingPrice ?? '-'}</td>
                                                    <td className="stocks-price-cell">{item.sellingPrice ?? '-'}</td>
                                                    <td className="stocks-total-cell"><span className="stocks-total">{totalStock}</span></td>
                                                    <td className="stocks-action-cell">
                                                        <div className="vendors-action-group">
                                                            <button
                                                                type="button"
                                                                className="vendors-icon-btn vendors-icon-btn--view"
                                                                title="View details"
                                                                aria-label={`View ${item.productName}`}
                                                                onClick={() => handleViewMore(item)}
                                                            >
                                                                <FaEye aria-hidden="true" />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="vendors-icon-btn vendors-icon-btn--edit"
                                                                title="Edit stock"
                                                                aria-label={`Edit ${item.productName}`}
                                                                onClick={() => { if (!selectedVendor) { toast.warn('Please select a vendor to edit.'); return; } openEditForProduct(item); }}
                                                            >
                                                                <FaEdit aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </Table>
                        </Card.Body>
                        <Card.Footer className="stocks-card-footer">
                            <div className="stocks-footer-content">
                                <span>
                                    {filteredData.length > 0
                                        ? `Showing ${indexOfFirstItem + 1}–${Math.min(indexOfLastItem, filteredData.length)} of ${filteredData.length}`
                                        : 'Showing 0 products'}
                                </span>
                                <div className="stocks-pagination">
                                    <nav>
                                        <ul className="pagination mb-0" aria-label="Stocks pagination">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link btn-sm"
                                                    onClick={() => setCurrentPage(1)}
                                                    aria-label="First page"
                                                >
                                                    «
                                                </button>
                                            </li>
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link btn-sm"
                                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                    aria-label="Previous page"
                                                >
                                                    &lt;
                                                </button>
                                            </li>
                                            <li className="page-item active">
                                                <button className="page-link btn-sm" aria-current="page">
                                                    {currentPage}
                                                </button>
                                            </li>
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link btn-sm"
                                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                    aria-label="Next page"
                                                >
                                                  &gt;
                                                </button>
                                            </li>
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link btn-sm"
                                                    onClick={() => setCurrentPage(totalPages)}
                                                    aria-label="Last page"
                                                >
                                                    »
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </Card.Footer>
                    </Card>

                    <Modal show={showModal} onHide={handleCloseModal} size="lg" dialogClassName="stock-details-modal">
                        <Modal.Header closeButton className="stock-details-header">
                            <Modal.Title>
                                <span className="stock-details-title-icon"><FaWarehouse aria-hidden="true" /></span>
                                <span>
                                    <small>Stock Details</small>
                                    {selectedProduct?.productName}
                                </span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="stock-details-body">
                            <div className="stock-details-overview">
                                <div className="stock-details-image">
                                    {selectedProduct?.productImages?.[0] ? (
                                        <img src={selectedProduct.productImages[0]} alt={selectedProduct?.productName} />
                                    ) : (
                                        <div className="stock-details-no-image">
                                            <FaWarehouse aria-hidden="true" />
                                            <span>No image available</span>
                                        </div>
                                    )}
                                </div>
                                <div className="stock-details-summary">
                                    <div className="stock-summary-badges">
                                        <span>{selectedProduct?.productType || 'N/A'}</span>
                                        <span>{selectedProduct?.categoryName || 'N/A'}</span>
                                        <span className="is-status">{selectedProduct?.availabilityStatus || 'Stock product'}</span>
                                    </div>
                                    <h2>{selectedProduct?.productName || 'Unnamed product'}</h2>
                                    <p className="stock-summary-vendor">
                                        Supplied by <strong>{selectedProduct?.productVendorName || 'N/A'}</strong>
                                    </p>
                                    <div className="stock-summary-facts">
                                        <div><span>Product ID</span><strong>{selectedProduct?.productId || 'N/A'}</strong></div>
                                        <div><span>Parent SKU</span><strong>{selectedProduct?.parentSKU || 'N/A'}</strong></div>
                                        <div><span>Measurement</span><strong>{selectedProduct?.measurement || 'N/A'}</strong></div>
                                    </div>
                                </div>
                            </div>

                            <section className="stock-detail-section stock-product-meta">
                            <h5>Product Information</h5>
                            <div className="row stock-detail-grid">
                                <div className="col-md-6">
                                    <p><strong>Veg/Non-Veg:</strong> {selectedProduct?.vegOrNonVeg || 'N/A'}</p>
                                    <p><strong>Status Code:</strong> {selectedProduct?.statusCode || 'N/A'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Created At:</strong> {formatDate(selectedProduct?.createdAt)}</p>
                                    <p><strong>Updated At:</strong> {formatDate(selectedProduct?.updatedAt)}</p>
                                </div>
                            </div>
                            </section>

                            <section className="stock-detail-section stock-pricing-section">
                            <h5>Pricing</h5>
                            <div className="row stock-detail-grid">
                                <div className="col-md-6">
                                    <p><strong>Buying Price:</strong> ₹{selectedProduct?.buyingPrice || 'N/A'}</p>
                                    <p><strong>Selling Price:</strong> ₹{selectedProduct?.sellingPrice || 'N/A'}</p>
                                    <p><strong>Per Item Price:</strong> ₹{selectedProduct?.perItemPrice || 'N/A'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Offer Type:</strong> {selectedProduct?.offerType || 'N/A'}</p>
                                    <p><strong>Offer Price:</strong> ₹{selectedProduct?.offerPrice || 'N/A'}</p>
                                </div>
                            </div>
                            </section>

                            <section className="stock-detail-section stock-weight-section">
                            <h5>Weight & Price Options</h5>
                            {['productWeightOption1', 'productWeightOption2', 'productWeightOption3', 'productWeightOption4']
                                .map((key, index) => selectedProduct?.[key])
                                .filter(option => option && option.weight)
                                .length > 0 ? (
                                <ul className="stock-weight-options">
                                    {['productWeightOption1', 'productWeightOption2', 'productWeightOption3', 'productWeightOption4']
                                        .map((key, index) => {
                                            const option = selectedProduct?.[key];
                                            if (!option || !option.weight) return null;
                                            return (
                                                <li key={index}>
                                                    <strong>Option {index + 1}</strong>
                                                    <span>Weight <b>{option.weight} {selectedProduct?.measurement}</b></span>
                                                    <span>Stock <b>{option.stock}</b></span>
                                                    <span>Price <b>₹{option.price}</b></span>
                                                    <span>Offer Price <b>₹{option.offerPrice}</b></span>
                                                    <span>Child SKU <b>{option.childSKU}</b></span>
                                                </li>
                                            );
                                        })}
                                </ul>
                            ) : (
                                <p className="stock-detail-empty">No weight options available</p>
                            )}
                            </section>

                            <section className="stock-detail-section stock-promotions-section">
                            <h5>Promotional Flags</h5>
                            <div className="row stock-detail-grid">
                                <div className="col-md-6">
                                    <p><strong>Today's Deals:</strong> {selectedProduct?.TodaysDeals ? 'Yes' : 'No'}</p>
                                    <p><strong>Fast Moving:</strong> {selectedProduct?.FastMoving ? 'Yes' : 'No'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Newly Arrived:</strong> {selectedProduct?.NewlyArrived ? 'Yes' : 'No'}</p>
                                    <p><strong>Frequently Bought Together:</strong> {selectedProduct?.FrequantlyBroughtTogether ? 'Yes' : 'No'}</p>
                                    <p><strong>Exclusive Offers:</strong> {selectedProduct?.ExclusiveOffersForYou ? 'Yes' : 'No'}</p>
                                </div>
                            </div>
                            </section>

                            <section className="stock-detail-section stock-calendar-section">
                            <h5>Calendar Information</h5>
                            <p><strong>Calendarised:</strong> {selectedProduct?.calendarised ? 'Yes' : 'No'}</p>
                            {selectedProduct?.calendarised && (
                                <>
                                    <p><strong>Start Date:</strong> {formatDate(selectedProduct?.startDate)}</p>
                                    <p><strong>End Date:</strong> {formatDate(selectedProduct?.endDate)}</p>
                                </>
                            )}
                            <p><strong>Indian Calendar:</strong> {selectedProduct?.indianCalendar ? 'Yes' : 'No'}</p>
                            {selectedProduct?.indianCalendar && (
                                <p><strong>Indian Calendar Date:</strong> {formatDate(selectedProduct?.indianCalendarDate)}</p>
                            )}
                            </section>

                            <section className="stock-detail-section stock-description-section stock-section-wide">
                            <h5>Description</h5>
                            <p><strong>About the Product:</strong> {selectedProduct?.aboutTheProduct || 'N/A'}</p>
                            <p><strong>Benefits:</strong> {selectedProduct?.benefits || 'N/A'}</p>
                            <p><strong>Storage and Use:</strong> {selectedProduct?.storageAndUse || 'N/A'}</p>
                            </section>
                        </Modal.Body>
                        <Modal.Footer className="stock-details-footer">
                            <Button className="stock-details-close" onClick={handleCloseModal}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={showEditModal} onHide={handleCloseModal} size="xl" className="stock-edit-modal">
                        <Modal.Header closeButton className="stock-edit-header">
                            <Modal.Title>
                                <span className="stock-edit-title-icon"><FaEdit aria-hidden="true" /></span>
                                <span>
                                    <small>Inventory</small>
                                    {editMode ? "Edit Stocks for Products" : selectedProduct?.productName}
                                </span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="stock-edit-body">
                            <div className="card stock-edit-card">
                                <div className="card-header stock-edit-card-head">
                                    <h5>Weight and Price Information</h5>
                                    <p>Update availability, pricing, weight options, and calendar settings.</p>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="productName" className="form-label">Product Name</label>
                                            <span className="stock-edit-required">*</span>
                                            <input
                                                type="text"
                                                className="form-control bg-light"
                                                id="productName"
                                                placeholder="Enter Product Name"
                                                value={editData.productName}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="availabilityStatus" className="form-label">Availability Status</label>
                                            <span className="stock-edit-required">*</span>
                                            <select
                                                className={`form-select bg-light ${errors.availabilityStatus ? 'is-invalid' : validFields.availabilityStatus ? 'is-valid' : ''}`}
                                                id="availabilityStatus"
                                                value={editData.availabilityStatus}
                                                onChange={(e) => {
                                                    setEditData({ ...editData, availabilityStatus: e.target.value });
                                                    validateField('availabilityStatus', e.target.value);
                                                }}
                                            >
                                                <option value="" disabled>Select status</option>
                                                <option value="available">Available</option>
                                                <option value="outOfStock">Out of Stock</option>
                                                <option value="discontinued">Discontinued</option>
                                            </select>
                                            {errors.availabilityStatus && (
                                                <small className="text-danger">{errors.availabilityStatus}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="price" className="form-label">Base Price</label>
                                            <span className="stock-edit-required">*</span>
                                            <input
                                                type="text"
                                                className={`form-control bg-light ${errors.price ? 'is-invalid' : validFields.price ? 'is-valid' : ''}`}
                                                id="price"
                                                placeholder="Enter Base Price"
                                                value={editData.price}
                                                onChange={(e) => {
                                                    const newPrice = e.target.value;
                                                    setEditData({ ...editData, price: newPrice, sellingPrice: newPrice });
                                                    validateField('price', newPrice);
                                                    validateField('sellingPrice', newPrice, editData.productName);
                                                }}
                                            />
                                            {errors.price && (
                                                <small className="text-danger">{errors.price}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="offerType" className="form-label">Offer Type</label>
                                            <span className="stock-edit-required">*</span>
                                            <select
                                                className={`form-select bg-light ${errors.offerType ? 'is-invalid' : validFields.offerType ? 'is-valid' : ''}`}
                                                id="offerType"
                                                value={editData.offerType}
                                                onChange={(e) => {
                                                    const newOfferType = e.target.value;
                                                    const nextEditData = applyOfferToWeightOptions(editData, newOfferType, editData.offerPrice);
                                                    const offerContext = { offerType: newOfferType, offerValue: editData.offerPrice };
                                                    setEditData(nextEditData);
                                                    validateField('offerType', newOfferType, null, offerContext);
                                                    validateField('offerPrice', editData.offerPrice, null, offerContext);
                                                    [1, 2, 3, 4].forEach((index) => {
                                                        const option = nextEditData[`productWeightOption${index}`];
                                                        if (index === 1 || (option.weight || '').toString().trim()) {
                                                            validateField(`weightOption${index}`, option, null, offerContext);
                                                        }
                                                    });
                                                }}
                                            >
                                                <option value="" disabled>Select Offer Type</option>
                                                <option value="fixed">Fixed</option>
                                                <option value="percentage">Percentage</option>
                                            </select>
                                            {errors.offerType && (
                                                <small className="text-danger">{errors.offerType}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="offerPrice" className="form-label">Offer Value</label>
                                            <span className="stock-edit-required">*</span>
                                            <input
                                                type="text"
                                                className={`form-control bg-light ${errors.offerPrice ? 'is-invalid' : validFields.offerPrice ? 'is-valid' : ''}`}
                                                id="offerPrice"
                                                placeholder={editData.offerType === 'percentage' ? 'Enter Percentage' : 'Enter Fixed Amount'}
                                                value={editData.offerPrice}
                                                onChange={(e) => {
                                                    const newOfferPrice = e.target.value;
                                                    const nextEditData = applyOfferToWeightOptions(editData, editData.offerType, newOfferPrice);
                                                    const offerContext = { offerType: editData.offerType, offerValue: newOfferPrice };
                                                    setEditData(nextEditData);
                                                    validateField('offerPrice', newOfferPrice, null, offerContext);
                                                    [1, 2, 3, 4].forEach((index) => {
                                                        const option = nextEditData[`productWeightOption${index}`];
                                                        if (index === 1 || (option.weight || '').toString().trim()) {
                                                            validateField(`weightOption${index}`, option, null, offerContext);
                                                        }
                                                    });
                                                }}
                                            />
                                            {errors.offerPrice && (
                                                <small className="text-danger">{errors.offerPrice}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="formStock" className="form-label">Stock</label>
                                            <input
                                                type="number"
                                                className="form-control bg-light"
                                                id="formStock"
                                                value={editData.stock}
                                                readOnly
                                            />
                                            <small className="text-muted">Total of the quantities below</small>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="formBuyingPrice" className="form-label">Buying Price</label>
                                            <span className="stock-edit-required">*</span>
                                            <input
                                                type="text"
                                                className={`form-control bg-light ${errors.buyingPrice ? 'is-invalid' : validFields.buyingPrice ? 'is-valid' : ''}`}
                                                id="formBuyingPrice"
                                                value={editData.buyingPrice}
                                                onChange={(e) => {
                                                    setEditData({ ...editData, buyingPrice: e.target.value });
                                                    validateField('buyingPrice', e.target.value);
                                                }}
                                            />
                                            {errors.buyingPrice && (
                                                <small className="text-danger">{errors.buyingPrice}</small>
                                            )}
                                        </div>
                                        <div className="col-12 mt-3 mb-2">
                                            <p className="stock-edit-hint">Add at least <strong>one</strong> weight option (e.g. 1 kg, 5 kg). Options 2–4 are optional.</p>
                                            {[1, 2, 3, 4].map((index) => {
                                                const option = editData[`productWeightOption${index}`] || { weight: '', stock: '', price: '' };
                                                const fieldError = errors[`weightOption${index}`];
                                                const fieldValid = validFields[`weightOption${index}`];
                                                const inputClass = `form-control form-control-sm bg-light ${fieldError ? 'is-invalid' : fieldValid ? 'is-valid' : ''}`;
                                                const updateOption = (field, value) => {
                                                    const newOption = { ...option, [field]: value };
                                                    if (field === 'price') {
                                                        const calculated = calculateOfferPrice(value, editData.offerType, editData.offerPrice);
                                                        newOption.offerPrice = calculated && calculated !== 'Invalid' ? calculated : '';
                                                    }
                                                    const nextEditData = { ...editData, [`productWeightOption${index}`]: newOption };
                                                    if (field === 'stock') {
                                                        nextEditData.stock = totalQuantityFromOptions(nextEditData);
                                                    }
                                                    setEditData(nextEditData);
                                                    validateField(`weightOption${index}`, newOption);
                                                };
                                                return (
                                                    <div key={index} className={`weight-option-block mb-3 p-3 ${fieldError ? 'border border-danger' : 'border'}`}>
                                                        <p className={`stock-edit-option-title mb-2 ${index === 1 ? 'is-required' : ''}`}>
                                                            Weight Option {index}{' '}
                                                            {index === 1 ? <span className="text-danger">*</span> : <span className="small">(optional)</span>}
                                                        </p>
                                                        <div className="row g-2 align-items-end">
                                                            <div className="col-md-3">
                                                                <label htmlFor={`editWeightOption${index}`} className="form-label small mb-0">Weight</label>
                                                                {index === 1 && <span className="small text-muted d-block">e.g. 1 kg, 5 kg</span>}
                                                                <input type="text" className={inputClass} id={`editWeightOption${index}`} placeholder={index === 1 ? 'e.g. 1 kg' : 'e.g. 5 kg'} value={option.weight ?? ''} onChange={(e) => updateOption('weight', e.target.value)} />
                                                            </div>
                                                            <div className="col-md-3">
                                                                <label htmlFor={`editStockOption${index}`} className="form-label small mb-0">Quantity (Stock)</label>
                                                                {index === 1 && <span className="small text-muted d-block">e.g. 50</span>}
                                                                <input type="text" className={inputClass} id={`editStockOption${index}`} placeholder="e.g. 50" value={option.stock ?? ''} onChange={(e) => updateOption('stock', e.target.value)} />
                                                            </div>
                                                            <div className="col-md-3">
                                                                <label htmlFor={`editPriceOption${index}`} className="form-label small mb-0">Price (₹)</label>
                                                                {index === 1 && <span className="small text-muted d-block">e.g. 100</span>}
                                                                <input type="text" className={inputClass} id={`editPriceOption${index}`} placeholder={index === 1 ? 'e.g. 100' : 'e.g. 80'} value={option.price ?? ''} onChange={(e) => updateOption('price', e.target.value)} />
                                                            </div>
                                                            <div className="col-md-3">
                                                                <label className="form-label small mb-0 text-muted">Offer Price (auto)</label>
                                                                {index === 1 && <span className="small text-muted d-block">&nbsp;</span>}
                                                                <div className={`form-control form-control-sm stock-edit-offer ${fieldError ? 'text-danger' : fieldValid ? 'text-success' : ''}`}>{calculateOfferPrice(option.price, editData.offerType, editData.offerPrice) || 'N/A'}</div>
                                                            </div>
                                                        </div>
                                                        {fieldError && <small className="text-danger d-block mt-1">{fieldError}</small>}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className="row stock-edit-toggles">
                                            <div className="col-12">
                                                <p className="stock-edit-section-label">Schedule</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label htmlFor="calendarised">Calendarised</label>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="calendarised"
                                                        checked={isCalendarised}
                                                        onChange={() => setIsCalendarised(!isCalendarised)}
                                                    />
                                                    <label className="form-check-label" htmlFor="calendarised"></label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <label htmlFor="indianCalendar">Indian Calendar</label>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="indianCalendar"
                                                        checked={isIndianCalendar}
                                                        onChange={() => setIsIndianCalendar(!isIndianCalendar)}
                                                    />
                                                    <label className="form-check-label" htmlFor="indianCalendar"></label>
                                                </div>
                                            </div>
                                        </div>
                                        {isCalendarised && (
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label htmlFor="startDate" className="form-label">Start Date</label>
                                                    <span className="stock-edit-required">*</span>
                                                    <input
                                                        type="date"
                                                        className={`form-control bg-light ${errors.startDate ? 'is-invalid' : validFields.startDate ? 'is-valid' : ''}`}
                                                        id="startDate"
                                                        value={startDate}
                                                        onChange={(e) => {
                                                            setStartDate(e.target.value);
                                                            validateField('startDate', e.target.value);
                                                        }}
                                                    />
                                                    {errors.startDate && (
                                                        <small className="text-danger">{errors.startDate}</small>
                                                    )}
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="endDate" className="form-label">End Date</label>
                                                    <span className="stock-edit-required">*</span>
                                                    <input
                                                        type="date"
                                                        className={`form-control bg-light ${errors.endDate ? 'is-invalid' : validFields.endDate ? 'is-valid' : ''}`}
                                                        id="endDate"
                                                        value={endDate}
                                                        onChange={(e) => {
                                                            setEndDate(e.target.value);
                                                            validateField('endDate', e.target.value);
                                                        }}
                                                    />
                                                    {errors.endDate && (
                                                        <small className="text-danger">{errors.endDate}</small>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {isIndianCalendar && (
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label htmlFor="indianCalendarDate" className="form-label">Indian Calendar Date</label>
                                                    <span className="stock-edit-required">*</span>
                                                    <input
                                                        type="date"
                                                        className={`form-control bg-light ${errors.indianCalendarDate ? 'is-invalid' : validFields.indianCalendarDate ? 'is-valid' : ''}`}
                                                        id="indianCalendarDate"
                                                        value={indianCalendarDate}
                                                        onChange={(e) => {
                                                            setIndianCalendarDate(e.target.value);
                                                            validateField('indianCalendarDate', e.target.value);
                                                        }}
                                                    />
                                                    {errors.indianCalendarDate && (
                                                        <small className="text-danger">{errors.indianCalendarDate}</small>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="stock-edit-footer">
                            <Button
                                onClick={handleCloseModal}
                                className="stock-edit-close"
                            >
                                Close
                            </Button>
                            <Button
                                onClick={handleUpdateProductStock}
                                className="stock-edit-save"
                            >
                                Save and Submit
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        show={Boolean(deleteTarget)}
                        onHide={() => setDeleteTarget(null)}
                        centered
                        dialogClassName="list-confirm-dialog"
                        contentClassName="list-confirm-modal"
                    >
                        <Modal.Body className="list-confirm-body">
                            <div className="list-confirm-icon" aria-hidden="true">
                                <FaTrashAlt />
                            </div>
                            <h3>Remove this stock?</h3>
                            <p>
                                <strong>{deleteTarget?.productName}</strong> will leave the stocks list and move back to products for <strong>{deleteTarget?.productVendorName || selectedVendor}</strong>.
                            </p>
                        </Modal.Body>
                        <Modal.Footer className="list-confirm-footer">
                            <Button className="list-confirm-cancel" onClick={() => setDeleteTarget(null)}>
                                Cancel
                            </Button>
                            <Button className="list-confirm-delete" onClick={confirmDeleteStock}>
                                Yes, remove
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                {!showModal && !showEditModal && <Footer />}
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={true}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    style={{ zIndex: 9999 }}
                />
            </div>
        </>
    );
};

export default ViewStocks;